import React from "react";
import DataGrid, {
  Column,
  LoadPanel,
  Scrolling,
  FilterRow,
  Selection
} from "devextreme-react/data-grid";
import { withStyles } from "@material-ui/core/styles";
import { columns } from "./utils";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "300px"
    }
  }
};

class SelectStudentTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      selectedStudents: [],
      focusedStudent: -1,
      focusedRowIndex: -1
    };

    this.selectStudents = this.selectStudents.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.dataGridRef = React.createRef();
  }

  selectStudents({ selectedRowsData }) {
    this.setState({ selectedStudents: selectedRowsData });
  }

  onRowClick(e) {
    const {onSelectedPerson} = this.props;
    const focusedStudent = e !== -1 ? e.data.id : e;
    const focusedRowIndex = e !== -1 ? e.rowIndex : e;
    this.setState({ focusedStudent, focusedRowIndex });
    onSelectedPerson && onSelectedPerson(focusedStudent);
  }

  render() {
    const {
      selectedStudents,
      focusedRowIndex,
      focusedStudent
    } = this.state;

    const {
      selectedPerson,
      personList,
      classes
    } = this.props;
    const { root } = classes;

    return (
      <div className={root}>
        <DataGrid
          elementAttr={{
            id: "gridContainer"
          }}
          ref={this.dataGridRef}
          wordWrapEnabled={true}
          dataSource={personList}
          onSelectionChanged={this.selectStudents}
          focusedRowEnabled
          errorRowEnabled={false}
          onRowClick={this.onRowClick}
          focusedRowIndex={focusedRowIndex}
          selection={{ mode: 'single' }}
          showBorders
        >
          {columns.map(column => (
            <Column key={column.dataField} {...column} />
          ))}
          <FilterRow visible={true} />
          <Scrolling mode="virtual" />
          <LoadPanel enabled/>
        </DataGrid>
      </div>
    );
  }
}

export default withStyles(styles)(SelectStudentTable);
